import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const useStyles = makeStyles((theme) =>
  createStyles({
    paper: {
      backgroundColor: theme.palette.type === 'dark' ? COLORS.DARK_BACKGROUND : COLORS.WHITE,
      border: theme.palette.type === 'dark' ? `1px solid ${COLORS.DARK_BORDER}` : `1px solid ${COLORS.LIGHT_BORDER}`,
      borderRadius: 8,
      boxShadow: 'none',
    },
  }),
);
